import { render, staticRenderFns } from "./customerPrompt.vue?vue&type=template&id=bf9b6a4a&scoped=true&"
import script from "./customerPrompt.vue?vue&type=script&lang=js&"
export * from "./customerPrompt.vue?vue&type=script&lang=js&"
import style0 from "./customerPrompt.vue?vue&type=style&index=0&id=bf9b6a4a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b6a4a",
  null
  
)

export default component.exports